import { Flex, Typography } from "antd";
import styles from "./plateItem.module.css";

import { ReactComponent as InfoIcon } from "images/info.svg";

interface PlateItemFooterProps {
  description: string | undefined;
  children: React.ReactNode | string;
}

export const PlateItemFooter = ({ description, children }: PlateItemFooterProps) => {
  const childrenComponent = typeof children === "string" ? <Typography.Text>{children}</Typography.Text> : children;

  return (
    <div className={styles.footerItemComponent}>
      <Flex justify="space-between" style={{ width: "100%" }} align="center">
        <Flex align="center" gap="small">
          <InfoIcon />
          <Typography.Text>{description}</Typography.Text>
        </Flex>
        {childrenComponent}
      </Flex>
    </div>
  );
};
